/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { task } from 'ember-concurrency';
import { ESCAPE } from 'cio/utils/keyboard';
import { guidFor } from '@ember/object/internals';

import { isEmpty } from '@ember/utils';

interface InlineEditArgs {
  disabled: boolean;
  inputClassNames: string;
  iconTooltipContentComponent?: string;
  iconTooltipContentClassNames?: string;
  editableContentClassNames?: string;
  asideContentClassNames?: string;
  placeholder: string;
  type: 'input' | 'textarea';
  allowEmpty?: boolean;
  value: string;
  truncate?: boolean;
  onClose?: () => unknown;
  onSave: (_: string | undefined) => unknown;
}

export default class InlineEdit extends Component<InlineEditArgs> {
  @tracked editedValue?: string;
  @tracked isEditing = false;

  readonly guid = guidFor(this);

  get disabledOrReadonly() {
    return this.args.disabled || this.saveTask.isRunning || (!this.allowEmpty && isEmpty(this.editedValue));
  }

  get allowEmpty() {
    return this.args.allowEmpty ?? true;
  }

  get isTextarea() {
    return this.args.type === 'textarea';
  }

  get truncate() {
    return this.args.truncate ?? true;
  }

  @action
  handleKeyUp(event: KeyboardEvent) {
    if (event.which === ESCAPE) {
      this.cancelEditing();
    }
  }
  @action
  cancelEditing() {
    this.isEditing = false;
    if (this.args.onClose) {
      this.args.onClose();
    }
  }

  saveTask = task({ drop: true }, async (event: Event) => {
    event.preventDefault();

    await this.args.onSave(this.editedValue);
    this.cancelEditing();
  });

  constructor(owner: unknown, args: InlineEditArgs) {
    super(owner, args);

    this.editedValue = args.value;
  }
}
